import { Component, OnInit } from '@angular/core';
import { CoreCustomCard } from '../../shared/core-custom-card.decorator';
import { CoreCardBaseComponent } from '../../shared/core-card-base.component';

@CoreCustomCard('standard')
@Component({
  selector: 'cu-standard-card',
  templateUrl: './standard-card.component.html',
  standalone: false
})
export class StandardCardComponent extends CoreCardBaseComponent implements OnInit {
  public ngOnInit(): void {}
}
